import { FC } from 'react';
import ProDatePicker from './datePicker';
import ProWeekPicke from './weekPicker';
import ProMonthPicker from './monthPicker';
import ProYearPicker from './yearPicker';
import ProRangePicker from './rangePicker';
import ProTimePicker from './timePicker';
import ProQuarterPicker from './quarterPicker';
import { DatePickerProps, MonthPickerProps, WeekPickerProps, RangePickerProps } from 'antd/lib/date-picker';
import { TimePickerProps } from 'antd/lib/time-picker';

export type IDatePickerComponent = FC<DatePickerProps> & {
  WeekPicke: FC<WeekPickerProps>;
  MonthPicker: FC<MonthPickerProps>;
  YearPicker: FC<DatePickerProps>;
  RangePicker: FC<RangePickerProps>;
  TimePicker: FC<TimePickerProps>;
  QuarterPicker: FC<DatePickerProps>;
};

const TransDatePicker = ProDatePicker as IDatePickerComponent;
TransDatePicker.WeekPicke = ProWeekPicke;
TransDatePicker.MonthPicker = ProMonthPicker;
TransDatePicker.YearPicker = ProYearPicker;
TransDatePicker.RangePicker = ProRangePicker;
TransDatePicker.TimePicker = ProTimePicker;
TransDatePicker.QuarterPicker = ProQuarterPicker;

export default TransDatePicker;
